import { z } from 'zod';

export enum GrantType {
  AuthnToken = 'authn_token',
  ClientCredentials = 'client_credentials',
  RefreshToken = 'refresh_token'
}

const usingAuthnTokenRequest = z.object({
  grant_type: z.literal(GrantType.AuthnToken),
  authn_token: z.string(),
  scope: z.string().optional(),
});

const usingClientCredentialsRequest = z.object({
  grant_type: z.literal(GrantType.ClientCredentials),
  client_id: z.string(),
  client_secret: z.string(),
  scope: z.string().optional(),
});

const usingRefreshTokenRequest = z.object({
  grant_type: z.literal(GrantType.RefreshToken),
  refresh_token: z.string().startsWith('ey').includes('.'),
  scope: z.string().optional(),
});

export const POST_SCHEMA = z.union([
  usingAuthnTokenRequest,
  usingClientCredentialsRequest,
  usingRefreshTokenRequest,
]);